/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import { IconAnchorLink } from '../blocks/IconAnchorLink';
import { BusinessForm } from '../forms/BusinessForm';
import { IconEndlessScroll } from '../blocks';
import { AnimatedHero } from '../blocks/AnimatedHero';
import { InputType } from '../../types';
import { EnterpriseBanner } from '../Banner';

export const BusinessPage = () => {
  return (
    <>
      <AnimatedHero
        content={[
          {
            title: 'The streaming strategy that <strong>flexes with&nbsp;you</strong>',
            className: 'max-w-[400px] md:max-w-[600px] mx-auto lg:mx-0 lg:max-w-[750px] 2xl:max-w-[900px]',
          },
          {
            bodyBase: 'Xumo harnesses the power of FAST with a comprehensive, modular tech stack that helps reach your goals — the easy way.',
            className: 'max-w-[350px] md:max-w-[500px] mx-auto lg:mx-0 lg:max-w-[665px]',
          },
          {
            ctaRow: [
              {
                href: '#contact',
                label: 'Get in touch',
                color: 'xumoAltBerryLight',
              },
            ],
          },
        ]}
        img="/static/images/refresh/2025/hero-img.png"
        mobileImg="/static/images/refresh/2025/hero-img-rotated.png"
        bgGradient="/static/images/refresh/2025/hero-bg.jpg"
      />
      <EnterpriseBanner />
      <IconAnchorLink
        bg="#EFF3F5"
        title={[{ headingAlt: '<strong>Award-winning streaming distribution</strong> — trusted by entertainment companies worldwide' }]}
        icons={[
          {
            icon: '/static/images/refresh/2025/icon-add-circle.svg',
            title: 'Creation',
            body: "We build channels everyone's watching",
          },
          {
            icon: '/static/images/refresh/2025/icon-antenna.svg',
            title: 'Distribution',
            body: 'We power streaming globally',
          },
          {
            icon: '/static/images/refresh/2025/icon-auto-payments.svg',
            title: 'Monetization',
            body: 'We optimize every interaction',
          },
          {
            icon: '/static/images/refresh/2025/icon-controls.svg',
            title: 'Analytics',
            body: 'We make insights transparent',
          },
          {
            icon: '/static/images/refresh/2025/icon-channels.svg',
            title: 'Aggregation',
            body: 'We have channels ready to go',
          },
        ]}
        content={[
          [
            { subheadingAlt: 'Creation' },
            { headingAlt: '<strong>We build channels</strong> everyone’s watching' },
            {
              subheadingAlt:
                'We have 2,000+ channels programmed through our robust content management system for partners of all sizes, perfect for content owners looking to create and distribute channels or distribution services looking to build out their channel listings.',
            },
          ],
          [
            { subheadingAlt: 'Distribution' },
            { headingAlt: '<strong>We distribute globally</strong> and to all major streaming servicess' },
            {
              subheadingAlt:
                'We have 30+ streaming endpoints worldwide, including 100% of all major streaming services, supporting multiple video formats and custom EPG with an award-winning distribution strategy, perfect for content owners looking to expand distribution or OEMs and FAST services looking to integrate with Xumo.',
            },
          ],
          [
            { subheadingAlt: 'Monetization' },
            { headingAlt: 'We optimize <strong>every interaction</strong>' },
            {
              subheadingAlt:
                'We gain 10B+ annual impressions maximizing revenue through 50+ demand partners, perfect for content owners looking to earn more revenue, distribution services looking to turn over monetization or work with a backfill partner or advertisers looking to understand Xumo’s FAST scale and opportunity.',
            },
            {
              ctaRow: [
                {
                  href: '/advertising',
                  label: 'Meet Xumo Advertising',
                  color: 'xumoAltBerryLight',
                },
              ],
            },
          ],
          [
            { subheadingAlt: 'Analytics' },
            { headingAlt: 'We make insights <strong>transparent</strong>' },
            {
              subheadingAlt:
                'Gain key viewership insights from our intelligence dashboard and institutional knowledge from Xumo Play, perfect for anyone and everyone looking to make gains in the FAST industry.',
            },
          ],
          [
            { subheadingAlt: 'Aggregation' },
            { headingAlt: 'We have channels <strong>ready to go</strong>' },
            {
              subheadingAlt:
                'Pick and choose from our Xumo House Channels to get your own collection of movie and television channels that are already generated, aggregated and syndicated for you, perfect for content owners looking to acquire additional programming, MVPDs looking to enhance their content offering or advertisers looking to access additional inventory.',
            },
          ],
        ]}
        images={[
          '/static/images/refresh/2025/creation.png',
          '/static/images/refresh/2025/distribution.png',
          '/static/images/refresh/2025/monetization.png',
          '/static/images/refresh/2025/analytics.png',
          '/static/images/refresh/2025/aggregation.png',
        ]}
        imgshadow={false}
      />
      {/* Endless Scroll Icons need min 5 icons per row */}
      <IconEndlessScroll
        bg="#EFF3F5"
        textbox={false}
        copy={[
          { heading: 'We&#39;re <strong>tuned in</strong>' },
          {
            body: 'Xumo partners with brands across the entire streaming industry — from consumer electronics to advertisers — to help get you wherever you want to go.',
          },
        ]}
        icons={[
          [
            '/static/images/refresh/2025/enterprise-logos/1-1.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-2.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-3.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-4.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-5.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-6.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-7.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-8.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-9.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-10.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-11.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-12.jpg',
            '/static/images/refresh/2026/q1-updates/pbs-logo.png',
            '/static/images/refresh/2025/enterprise-logos/1-14.jpg',
            '/static/images/refresh/2025/enterprise-logos/1-15.jpg',
          ],
          [
            '/static/images/refresh/2025/enterprise-logos/2-1.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-2.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-4.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-5.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-6.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-7.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-8.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-9.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-10.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-11.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-12.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-13.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-14.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-15.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-16.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-17.jpg',
            '/static/images/refresh/2025/enterprise-logos/2-18.jpg',
          ],
          [
            '/static/images/refresh/2025/enterprise-logos/3-1.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-2.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-3.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-4.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-5.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-6.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-7.jpg',
            '/static/images/refresh/2026/q1-updates/peacock-logo.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-9.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-10.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-11.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-12.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-13.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-14.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-15.jpg',
            '/static/images/refresh/2025/enterprise-logos/3-16.jpg',
          ],
        ]}
      />
      <BusinessForm
        heading="<h3>Get started <strong>today</strong></h3>"
        body="<p>Connect with our team to learn how you can leverage Xumo for your unique FAST needs.</p>"
        formFields={[
          {
            type: InputType.Name,
            name: 'first_name',
            placeholder: 'First name',
          },
          {
            type: InputType.Name,
            name: 'last_name',
            placeholder: 'Last name',
          },
          {
            type: InputType.Email,
            name: 'email',
            placeholder: 'Email',
          },
          {
            type: InputType.Name,
            name: 'company',
            placeholder: 'Company',
          },
          {
            type: InputType.Textarea,
            name: 'message',
            placeholder: 'Message',
            width: 'full',
          },
        ]}
        CTA={{
          label: 'Submit',
          href: ' ',
        }}
        backgroundColor="#ffffff"
        headingOne={true}
        styleOverrides={{
          form: 'mt-16 gap-2',
          formField: 'rounded-none outline-1 outline-[#C2C2C2] placeholder:text-black',
          hideLabel: true,
          CTA: { alignment: 'w-full md:w-fit self-center mt-6' },
          accentColor: 'xumoAltBerryLight',
          hoverColor: 'xumoAltBerryDark',
        }}
      />
    </>
  );
};
